import Blocks from "../blocks";
import Layers from "../layers";
import Toggle from "./toggle";
import { useState } from "react";
import styles from "./styles.module.css";
import OpenWorkflows from "./openworkflows";
import OpenUtilites from "./openutilities";

export default function Sidebar() {
  const [tab, setTab] = useState("blocks");
  return (
    <div className={styles.sidebar}>
      <Toggle tab={tab} setTab={setTab} />
      <div style={{ height: "400px", overflowY: "hidden" }}>
        <Blocks open={tab === "blocks"} />
        <Layers open={tab === "layers"} />
      </div>
      <div className={styles.buttonContainer}>
        <OpenUtilites />
        <OpenWorkflows />
      </div>
    </div>
  );
}
